import { ActionType } from '@/actions';
import { ActionToggleAdditionalGame } from './interfaces';

export const toggleAdditionalGame = (
  game: number,
  additionalGameId: number
): ActionToggleAdditionalGame => {
  return {
    type: ActionType.ADDITIONAL_GAME_TOGGLED,
    game,
    additionalGameId,
  };
};
